import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={buildWhatsAppLink("Hola San José Shipping, me interesa cotizar un envío.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-[99] w-16 h-16 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform flex items-center justify-center group"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2.25} />
      <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0B1F4D] text-white text-xs uppercase tracking-wider font-bold px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        ¿Necesitas ayuda?
      </span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    </a>
  );
}
